import React from "react";
import { Link } from "react-router-dom";
import styles from "./PageNotFound.module.css";

const PageNotFound = () => {
  return (
    <div className={styles.root}>
      <div className={styles.crayonMarks} aria-hidden>
        <div className={styles.crayonMark} />
        <div className={styles.crayonMark} />
        <div className={styles.crayonMark} />
        <div className={styles.crayonMark} />
      </div>

      <div className={styles.pageContainer}>
        <div className={styles.drawingContainer}>
          <div className={styles.drawingPage}>
            <span className={styles.drawn404}>404</span>
          </div>

          <div className={styles.pencil} aria-hidden>
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="16" y="4" width="10" height="32" rx="1" fill="#C46070" />
              <rect x="16" y="4" width="10" height="6" rx="1" fill="#B05464" />
              <polygon points="16,36 26,36 21,46" fill="#EDE4D8" />
              <line
                x1="21"
                y1="36"
                x2="21"
                y2="44"
                stroke="#8C6D55"
                strokeWidth="1"
              />
              <rect x="16" y="32" width="10" height="4" fill="#B89B72" />
            </svg>
          </div>

          <svg className={styles.scribble} viewBox="0 0 60 30" aria-hidden>
            <path d="M0,15 C10,5 15,25 25,12 C35,0 40,20 55,10" />
          </svg>
        </div>

        <h1 className={styles.title}>Oops — this page went outside the lines</h1>
        <p className={styles.description}>
          The page you&apos;re looking for doesn&apos;t exist, but your coloring
          book memories are safe and sound.
        </p>

        <Link to="/" className={styles.btnPrimary}>
          Back to Memory Doodle
        </Link>

        <p className={styles.helpText}>
          Or go straight to{" "}
          <Link to="/dashboard" className={styles.helpLink}>
            my books
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PageNotFound;
